export const AUTH_TOKEN = "auth_token";
export const AUTH_USER = "auth_user";
